// Copyright ©️ 2026 eVolve MEP, LLC

import type { InsightsChartStatus } from '@evolvemep/api-ts';

export const statusToChartColorMap: Record<InsightsChartStatus, `#${string}`> = {
  'Draft': '#00CCCC',
  'Rejected': '#FD7272',
  'Submitted': '#4400CC',
  'Approved': '#008C4F',
  'Canceled': '#ADB5BD',
  'Not Started': '#F59F00',
  'In Progress': '#008ACC',
  'Completed': '#00CC88',
  'Blocked': '#F25A00',
  'Late': '#F91100',
};
